import './footer.css'
import React from 'react'

const Footer = () => {
  return (
    <section id='footer'>
        <div className="container">
            <div className="footercontainer">
                <p>All right reserved by Nazmul Hossain</p>
            </div>
        </div>
    </section>
  )
}

export default Footer